export const AvailabilityType = {
  isFulfillableIRGSku: {
    // eslint-disable-next-line id-length
    read(_, _ref) {
      let {
        readField
      } = _ref;
      const buyable = readField('buyable');
      const discontinued = readField('discontinued');
      const status = readField('status');
      return !!(buyable && status && !discontinued);
    }
  }
};
//# sourceMappingURL=AvailabilityType.js.map